import { render, staticRenderFns } from "./NewsMessageDialog.vue?vue&type=template&id=36421572&scoped=true"
import script from "./NewsMessageDialog.vue?vue&type=script&lang=js"
export * from "./NewsMessageDialog.vue?vue&type=script&lang=js"
import style0 from "./NewsMessageDialog.vue?vue&type=style&index=0&id=36421572&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36421572",
  null
  
)

export default component.exports